import * as React from 'react';
import { getDeveloper } from '../../selectors/developerV2';
import { useSelector } from 'react-redux';
import { Image } from '@cian/ui-kit';
import { RedesignIntroduction } from '../../components/Introduction/RedesignIntroduction';
import { Heading } from '../../components/Heading';
import { Ratings } from '../RatingsRedesigned';
import { ContactButtonsContainer } from '../ContactButtonsRedesigned';
import { BreadCrumbs } from '../BreadCrumbs';

export const Introduction = () => {
  const { poster, logoUrl, name } = useSelector(getDeveloper);

  return (
    <div>
      <RedesignIntroduction
        breadcrumbs={<BreadCrumbs />}
        backgroundImage={poster && <Image src={poster} objectFit="cover" width="100%" height="100%" borderRadius={0} />}
        title={<Heading name={name} />}
        logo={<Image src={logoUrl} width="100%" height="100%" objectFit="contain" borderRadius="4px" />}
        contacts={<ContactButtonsContainer />}
        rating={<Ratings />}
      />
    </div>
  );
};
